import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { groupSupplierDocuments } from 'features/supplier/utils';

import ModalContainer from '@components/modals/ModalContainer';
import ModalHeader from '@components/modals/ModalHeader';

import SupplierDocumentUpload from '@features/supplier/component/SupplierDocumentUpload';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { updateSafetyInformation } from '@services/supplierOnboardingService';

import { printApiError } from '@utils/Util';

const AddSafetyInformation = ({ onClose, safetyInfo, callBack, documentTypes }) => {
	const [inputData, setInputData] = useState({});
	const [errors, setErrors] = useState({});
	const { id } = useParams();
	const dispatch = useDispatch();

	useEffect(() => {
		setInputData(safetyInfo);
	}, [id, safetyInfo]);

	const handleChange = (e) => {
		const { name, value } = e.target;
		setInputData((prev) => ({ ...prev, [name]: value }));
	};

	const isValid = () => {
		let err = {};
		if (!inputData?.noOfFloors) {
			err['noOfFloorsError'] = 'Field is required';
		}
		if (!inputData?.sizeOfFloors) {
			err['sizeOfFloorsError'] = 'Field is required';
		}
		if (!inputData?.totalSpace) {
			err['totalSpaceError'] = 'Field is required';
		}
		if (!inputData?.totalAreaOfFactoryPremise) {
			err['totalAreaOfFactoryPremiseError'] = 'Field is required';
		}
		setErrors(err);
		return Object.keys(err).length === 0;
	};

	const handleSubmit = async () => {
		if (isValid()) {
			try {
				dispatch(openLoader());
				await updateSafetyInformation(id, inputData);
				onClose(true);
				dispatch(closeLoader());
			} catch (e) {
				printApiError(e);
				dispatch(closeLoader());
			}
		}
	};

	const renderDocumentUpload = () => {
		const groupedDocuments = groupSupplierDocuments(
			safetyInfo.documentResponseList,
			'safetyDocumentType'
		);
		return documentTypes?.map((item) => {
			let existingDocuments = groupedDocuments[item.id]?.map((existingDoc) => ({
				...existingDoc.documentResponse
			}));
			return (
				<React.Fragment key={`document_upload_${item.id}`}>
					<SupplierDocumentUpload
						title={item.value}
						fieldName={item.id}
						multiple={false}
						uploadType="SAFETY_INFORMATION"
						callBack={callBack}
						documents={{ [item.id]: existingDocuments }}
					/>
				</React.Fragment>
			);
		});
	};

	return (
		<ModalContainer className="filter-quick-search-modal safety-info-modal">
			<div className="common-popup">
				<ModalHeader title="Safety Information" onClose={onClose} />

				<div className="common-popup-body scroll-y-label">
					<div className="container px-0">
						<div className="row">
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="noOfFloors">Number of Floors</label>
									<input
										type="number"
										className="w-100"
										id="noOfFloors"
										name="noOfFloors"
										value={inputData?.noOfFloors || ''}
										onChange={handleChange}
									/>
									{errors?.noOfFloorsError && (
										<p className="error">{errors.noOfFloorsError}</p>
									)}
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="sizeOfFloors">Size of Floor (Sqft.)</label>
									<input
										type="number"
										className="w-100"
										id="sizeOfFloors"
										name="sizeOfFloors"
										value={inputData?.sizeOfFloors || ''}
										onChange={handleChange}
									/>
									{errors?.sizeOfFloorsError && (
										<p className="error">{errors.sizeOfFloorsError}</p>
									)}
								</div>
							</div>

							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="totalSpace">Total Space (Sqft.)</label>
									<input
										type="number"
										className="w-100"
										id="totalSpace"
										name="totalSpace"
										value={inputData?.totalSpace || ''}
										onChange={handleChange}
									/>
									{errors?.totalSpaceError && (
										<p className="error">{errors.totalSpaceError}</p>
									)}
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<label htmlFor="totalAreaOfFactoryPremise">
										Total Areas of Factory Premises (Sqrt)
									</label>
									<input
										type="number"
										className="w-100"
										id="totalAreaOfFactoryPremise"
										name="totalAreaOfFactoryPremise"
										value={inputData?.totalAreaOfFactoryPremise || ''}
										onChange={handleChange}
									/>
									{errors?.totalAreaOfFactoryPremiseError && (
										<p className="error">{errors.totalAreaOfFactoryPremiseError}</p>
									)}
								</div>
							</div>

							<div className="col-md-12">
								<div className="quick-info-files">{renderDocumentUpload()}</div>
							</div>
						</div>
					</div>
				</div>
				<div className="modal-footer">
					<div className="footer-buttons text-right">
						<button className="button gray-outline size32" onClick={onClose}>
							Cancel
						</button>
						<button className="button size32 ml-2" onClick={handleSubmit}>
							Submit
						</button>
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default AddSafetyInformation;
